import { Injectable } from '@angular/core';
import { AccountingPeriodsApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { AccountingPeriodsAction } from '../actions';

@Injectable()
export class AccountingPeriodsEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(AccountingPeriodsAction.loadItem),
      exhaustMap(action => {
        return this._apiService.getLastAccountingPeriod(action.id).pipe(map(item => AccountingPeriodsAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: AccountingPeriodsApiService, private _actions$: Actions, private _store: Store) {}
}
